module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/87JsFj/cover.jpeg?1684975174776",
      "alt": "This image is the cover for the book New Game, Start, 2017 Advent Calendar - Stocking Stuffers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Game, Start, 2017 Advent Calendar - Stocking Stuffers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Reclusive medieval scholar, Edgar Royal, has a crush. On a guy. Not a big deal, except that said guy, Walter Chase, is a famous online gamer who has no idea Edgar even exists. Edgar has harbored these feelings for nearly a year, and when Walter announces on Twitter that he’ll be visiting New York City as a guest at the GamerOn convention, Edgar decides he’ll be one of the thousands of fans who responds to the message.")]), _vm._v(" "), _c('p', [_vm._v("He definitely doesn’t expect to be singled out by the humble, gorgeous, out-and-proud heartthrob. And when it comes to dealing with people, Edgar’s skills are pretty nonexistent. Even with Walter giving all the right signals, Edgar lacks the courage do anything about the mutual attraction growing through their online courtship. He’s always been better with the written word, so maybe the perfect Christmas gift will say what he cannot. But if Edgar can’t get the present to Walter before the convention ends, he may miss out on the boyfriend of a lifetime.")]), _c('p', [_c('i', [_vm._v("A story from the Dreamspinner Press 2017 Advent Calendar \"Stocking Stuffers.\"")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C.S. Poe\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0